import React from "react";
import "../index.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        <div className="footer-brand">
          <h2>Gxpress Solutions</h2>
          <p>Один партнёр. Полный комплекслогистических услуг.</p>
        </div>

        <div className="footer-links">
          <h4>Быстрые ссылки</h4>
          <a href="/">Главная страница</a>
          <a href="/about">О нас</a>
          <a href="/contact">Контакты</a>
        </div>

        <div className="footer-website">
          <h4>Официальный сайт</h4>
          <a 
            href="https://gxpresss.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            gxpresss.com
          </a>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Gxpress Solutions. Все права защищены.
      </div>
    </footer>
  );
};

export default Footer;